import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';

@Injectable({providedIn: 'root'})
export class ReportsService {

  url:string = `${environment['API_URL']}`

  constructor(private http: HttpClient,) {
  }

  // getAccounts(endpoint: string){
  //   //{ headers: headers, params: params }
  //   let url = `${this.url}/${endpoint}`;
  //   return this.http.get< AccountInterfaceData[]>(url);
  //   // {observe: 'response'} main.js:1 ERROR TypeError: t.payload is not iterable
  // } //end login

  get(endpoint: string){
    //{ headers: headers, params: params }
    //let headers = { 'Content-Type': 'application/json' };
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new Headers(headerDict),
    };


    let url = `${this.url}/${endpoint}`;
    // https://stackoverflow.com/questions/32463340/angular-gzip-json-file-automatically-refused-to-set-unsafe-header-accept-enco  Accept-Encoding':'gzip'
    // headers: {'Content-Encoding': 'gzip'},
    return this.http.get(url,{ observe: 'response'});
  } //end get

  get_psurl(endpoint: string){
    //{ headers: headers, params: params }
    //let headers = { 'Content-Type': 'application/json' };
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new Headers(headerDict),
    };


    let url = `${endpoint}`;
    // https://stackoverflow.com/questions/32463340/angular-gzip-json-file-automatically-refused-to-set-unsafe-header-accept-enco  Accept-Encoding':'gzip'
    // headers: {'Content-Encoding': 'gzip'},
    return this.http.get(url,{ observe: 'response'});
  } //end get



} // end class


